"use strict";
globalThis.RALColors = (() => {
  const { $ } = Utils;
  const COLORS = Object.freeze([
    { code: "9016", hex: "#f6f6f6", name: "Verkeerswit" },
    { code: "9001", hex: "#eae0c8", name: "Cr\xE8mewit" },
    { code: "9010", hex: "#f4f4ec", name: "Zuiver wit" },
    { code: "9005", hex: "#0a0a0a", name: "Gitzwart" },
    { code: "7016", hex: "#383e42", name: "Antracietgrijs" },
    { code: "7021", hex: "#2f3234", name: "Zwartgrijs" },
    { code: "7035", hex: "#c5c7c4", name: "Lichtgrijs" },
    { code: "6009", hex: "#27352a", name: "Dennegroen" },
    { code: "6005", hex: "#0f4336", name: "Mosgroen" },
    { code: "5011", hex: "#1a2b3c", name: "Staalblauw" },
    { code: "5014", hex: "#607b94", name: "Duifblauw" },
    { code: "3005", hex: "#59191f", name: "Wijnrood" },
    { code: "8014", hex: "#473121", name: "Sepiabruin" },
    { code: "8017", hex: "#45322e", name: "Chocoladebruin" }
  ]);
  const getAll = () => COLORS;
  const findByCode = (code) => COLORS.find((c) => c.code === code);
  const buildListHTML = () => COLORS.map((c) => `
        <button type="button" class="ral-color-btn flex items-center gap-3 p-3 hover:bg-neutral-50 active:bg-neutral-100 transition-colors w-full text-left" data-ral="${c.code}">
            <div class="w-12 h-12 rounded-lg border border-neutral-200 shrink-0" style="background:${c.hex}"></div>
            <div class="flex-1 min-w-0">
                <div class="font-bold text-neutral-900">RAL ${c.code}</div>
                <div class="text-sm text-neutral-500 truncate">${c.name}</div>
            </div>
            <i data-lucide="chevron-right" class="w-5 h-5 text-neutral-300"></i>
        </button>
    `).join("");
  const openPicker = (onSelect) => {
    Bottomsheet.open({
      title: "Meer RAL kleuren",
      content: `<div class="divide-y divide-neutral-100">${buildListHTML()}</div>`
    });
    const handleClick = (e) => {
      const btn = e.target.closest(".ral-color-btn");
      if (!btn) return;
      const code = btn.dataset.ral;
      onSelect?.(code);
      Bottomsheet.close();
      document.removeEventListener("click", handleClick);
    };
    setTimeout(() => document.addEventListener("click", handleClick), 100);
  };
  const selectColor = (code, inputName = "wizard-ral") => {
    let radio = $(`input[name="${inputName}"][value="${code}"]`);
    if (!radio) {
      const container = $(`.wizard-option-group[data-group="${inputName}"]`) || $(`input[name="${inputName}"]`)?.closest("div");
      if (container) {
        const label = document.createElement("label");
        label.className = "hidden";
        label.innerHTML = `<input type="radio" name="${inputName}" value="${code}" class="sr-only" />`;
        container.appendChild(label);
        radio = label.querySelector("input");
      }
    }
    if (radio) {
      radio.checked = true;
      Wizard.updateGroupStyles(inputName);
    }
    State.wizard.set("ral", code);
    return radio;
  };
  return Object.freeze({
    COLORS,
    getAll,
    findByCode,
    openPicker,
    selectColor
  });
})();
